export default function WorkflowSection() {
  return (
    <section className="qdk" id="s3">
      <div className="wrap">
        <div className="qhd pd-rv">
          <div>
            <span className="ey">
              <b>03</b>
              워크플로우 빌더
            </span>
            <small>반복되는 업무를 나만의 흐름으로</small>
            <h2>
              노드를 연결해 만드는
              {' '}
              <em>AI 업무 흐름</em>
            </h2>
          </div>
        </div>
        <div className="qwf pd-rv">
          <div className="demo">
            <div className="pal">
              <h4>기능 선택</h4>
              <p>필요한 기능(노드)을 골라 업무 흐름에 추가합니다.</p>
              <small>
                트리거
                <span>2</span>
              </small>
              <div className="it">
                <i style={{ background: "var(--org)" }}>
                  <svg className="i">
                    <use href="#clock" />
                  </svg>
                </i>
                스케줄
              </div>
              <div className="it">
                <i style={{ background: "var(--grn)" }}>
                  <svg className="i">
                    <use href="#msg" />
                  </svg>
                </i>
                채팅시작
              </div>
              <small>
                액션
                <span>3</span>
              </small>
              <div className="it" data-k="ai">
                <i style={{ background: "var(--pnk)" }}>
                  <svg className="i">
                    <use href="#spark" />
                  </svg>
                </i>
                AI 응답 (LLM)
              </div>
              <div className="it">
                <i style={{ background: "var(--blu)" }}>
                  <svg className="i">
                    <use href="#doc" />
                  </svg>
                </i>
                문서 검색
              </div>
              <div className="it">
                <i style={{ background: "#F97316" }}>
                  <svg className="i">
                    <use href="#branch" />
                  </svg>
                </i>
                판단
              </div>
              <small>
                커넥터
                <span>1</span>
              </small>
              <div className="it">
                <i style={{ background: "var(--ac)" }}>
                  <svg className="i">
                    <use href="#mail" />
                  </svg>
                </i>
                이메일 커넥터
              </div>
            </div>
            <div className="cv">
              <div className="tb">
                AcXion-On · 워크플로우 빌더
                <span className="st">
                  <i />
                  <b>편집 중</b>
                </span>
                <span className="sp" />
                <button className="replay">
                  <svg className="i">
                    <use href="#replay" />
                  </svg>
                  다시 보기
                </button>
                <a className="btn p sm" href="#" style={{ height: "30px", fontSize: "12px" }}>저장</a>
              </div>
              <div className="stg">
                <svg className="wires" viewBox="0 0 600 440" />
                <div className="nd" data-n="n1" style={{ left: "20px", top: "30px" }}>
                  <span className="ic" style={{ background: "var(--grn)" }}>
                    <svg className="i">
                      <use href="#msg" />
                    </svg>
                  </span>
                  <span>
                    채팅 시작
                    <small>트리거</small>
                  </span>
                  <span className="ok">
                    <svg className="i">
                      <use href="#check" />
                    </svg>
                  </span>
                </div>
                <div className="nd" data-n="n2" style={{ left: "400px", top: "30px" }}>
                  <span className="ic" style={{ background: "var(--blu)" }}>
                    <svg className="i">
                      <use href="#doc" />
                    </svg>
                  </span>
                  <span>
                    문서 검색
                    <small>액션</small>
                  </span>
                  <span className="ok">
                    <svg className="i">
                      <use href="#check" />
                    </svg>
                  </span>
                </div>
                <div className="nd drag" data-n="n3" style={{ left: "210px", top: "190px" }}>
                  <span className="ic" style={{ background: "var(--pnk)" }}>
                    <svg className="i">
                      <use href="#spark" />
                    </svg>
                  </span>
                  <span>
                    AI 응답 (LLM)
                    <small>모델 · 프롬프트 설정</small>
                  </span>
                  <span className="ok">
                    <svg className="i">
                      <use href="#check" />
                    </svg>
                  </span>
                </div>
                <div className="nd" data-n="n4" style={{ left: "400px", top: "350px" }}>
                  <span className="ic" style={{ background: "var(--ac)" }}>
                    <svg className="i">
                      <use href="#mail" />
                    </svg>
                  </span>
                  <span>
                    이메일 커넥터
                    <small>커넥터</small>
                  </span>
                  <span className="ok">
                    <svg className="i">
                      <use href="#check" />
                    </svg>
                  </span>
                </div>
                <div className="pop" style={{ left: "20px", top: "290px" }}>
                  <b>
                    문서 검색
                    <span>노드 설정</span>
                  </b>
                  <div>
                    <span>지식베이스</span>
                    사내 규정 KB
                  </div>
                  <div>
                    <span>Top K</span>
                    5
                  </div>
                  <div>
                    <span>유사도 임계값</span>
                    0.70
                  </div>
                </div>
                <i className="pulse" />
                <span className="cur">
                  <svg viewBox="0 0 22 22">
                    <use href="#ptr" />
                  </svg>
                </span>
              </div>
              <div className="zoomc">
                <i>
                  <svg className="i">
                    <use href="#minus" />
                  </svg>
                </i>
                <i>
                  <svg className="i">
                    <use href="#plus" />
                  </svg>
                </i>
              </div>
            </div>
            <div className="chat">
              <div className="hd">
                <span className="av">AI</span>
                <div>
                  <small>사용자 포탈</small>
                  <b>업무에 필요한 답을, 바로</b>
                </div>
                <em>챗봇</em>
              </div>
              <div className="bd">
                <div className="m u">휴가 신청 절차를 알려주세요.</div>
                <div className="m s">
                  <svg className="i">
                    <use href="#search" />
                  </svg>
                  문서 검색 중
                </div>
                <div className="m s">
                  <svg className="i">
                    <use href="#spark" />
                  </svg>
                  AI 응답 생성 중
                </div>
                <div className="m a">
                  사내 규정에서 필요한 내용을 찾아 안내합니다.
                  <span className="srcc">
                    <svg className="i">
                      <use href="#doc" />
                    </svg>
                    출처 · 사내 업무 매뉴얼
                  </span>
                </div>
              </div>
              <div className="in">
                <span>무엇을 물어볼까요?</span>
                <i>
                  <svg className="i">
                    <use href="#up" />
                  </svg>
                </i>
              </div>
            </div>
          </div>
        </div>
        <div className="qc2" style={{ marginTop: "20px" }}>
          <div className="qdc pd-rv">
            <h4>화면에서 연결하는 업무 흐름</h4>
            <p>필요한 기능을 연결해 업무에 맞는 워크플로우를 만듭니다.</p>
            <ul>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                드래그 앤 드롭으로 노드 배치·연결
              </li>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                노드별 세부 설정과 편집 내용 저장
              </li>
            </ul>
          </div>
          <div className="qdc pd-rv d1">
            <h4>챗봇 설정부터 포탈 배포까지</h4>
            <p>배포한 챗봇은 사용자 포탈에 자동으로 표시됩니다.</p>
            <ul>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                챗봇 이름·화면 스타일·AI 응답 설정
              </li>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                설정 오류 확인 및 원클릭 배포
              </li>
            </ul>
          </div>
        </div>
        <div className="qsub pd-rv">워크플로우 주요 기능</div>
        <div className="qntb pd-rv">
          <div className="r h">
            <span>구분</span>
            <span>노드</span>
            <span>주요 설정 · 기능</span>
          </div>
          <div className="r">
            <span className="cat t">트리거</span>
            <div className="nm">
              <span className="ic" style={{ background: "var(--grn)" }}>
                <svg className="i">
                  <use href="#msg" />
                </svg>
              </span>
              채팅 시작
            </div>
            <p>사용자가 메시지를 보내면 워크플로우 시작</p>
          </div>
          <div className="r">
            <span className="cat t">트리거</span>
            <div className="nm">
              <span className="ic" style={{ background: "var(--org)" }}>
                <svg className="i">
                  <use href="#clock" />
                </svg>
              </span>
              스케줄
            </div>
            <p>정해둔 시간에 워크플로우 자동 실행</p>
          </div>
          <div className="r">
            <span className="cat a">액션</span>
            <div className="nm">
              <span className="ic" style={{ background: "var(--pnk)" }}>
                <svg className="i">
                  <use href="#spark" />
                </svg>
              </span>
              AI 응답 (LLM)
            </div>
            <p>
              모델·답변 다양성(Temperature)·AI 지침(시스템 프롬프트) 설정, 답변 언어·형식·길이, 최대 토큰 수와 한 번에 읽을 정보량 조정, 실시간 답변·출처 표시 설정
            </p>
          </div>
          <div className="r">
            <span className="cat a">액션</span>
            <div className="nm">
              <span className="ic" style={{ background: "var(--blu)" }}>
                <svg className="i">
                  <use href="#doc" />
                </svg>
              </span>
              문서 검색
            </div>
            <p>검색할 지식베이스, 결과 수(Top K), 최소 유사도 점수 설정</p>
          </div>
          <div className="r">
            <span className="cat c">커넥터</span>
            <div className="nm">
              <span className="ic" style={{ background: "var(--ac)" }}>
                <svg className="i">
                  <use href="#mail" />
                </svg>
              </span>
              이메일 커넥터
            </div>
            <p>SMTP/IMAP으로 이메일 주고받기</p>
          </div>
          <div className="r">
            <span className="cat c">커넥터</span>
            <div className="nm">
              <span className="ic w">
                <img src="/site/logos/slack.svg" alt="" />
              </span>
              Slack
            </div>
            <p>Slack 메시지 주고받기</p>
          </div>
          <div className="r">
            <span className="cat c">커넥터</span>
            <div className="nm">
              <span className="ic w">
                <img src="/site/logos/notion.svg" alt="" />
              </span>
              Notion
            </div>
            <p>Notion 페이지 읽기·만들기</p>
          </div>
        </div>
        <div className="pnote pd-rv">
          <span>기능을 나타내는 노드를 끌어다 놓고 연결해 업무 흐름을 만듭니다.</span>
          <span>챗봇 설정과 오류 확인을 마치면 사용자 포탈에 배포할 수 있습니다.</span>
        </div>
      </div>
    </section>
  );
}
